.fieldFrame {
  height: 56px;
  background: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: 8px;
  overflow: hidden;
  cursor: text;

  &:focus-within {
    border-color: var(--mantine-primary-color-filled);
    box-shadow: inset 0 0 0 1px var(--mantine-primary-color-filled);
  }

  &[data-error] {
    border-color: var(--mantine-color-error);
  }

  &[data-disabled] {
    background: var(--mantine-color-gray-0);
  }
}

.field {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0 16px;
  border: 0;
  background: transparent;
  outline: none;
  font-family: var(--mantine-font-family-monospace);
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: var(--mantine-color-gray-9);
  font-variant-numeric: tabular-nums;

  &:disabled,
  &:read-only {
    color: var(--mantine-color-gray-6);
  }

  /* Placeholders are hints, not values: the regular text font at a quieter size. */
  &::placeholder {
    font-family: var(--mantine-font-family);
    font-size: 16px;
    font-weight: 400;
    letter-spacing: normal;
    color: var(--mantine-color-placeholder);
  }
}

.quickFill {
  margin-top: 8px;
}

.quickFillButton {
  flex: 1 1 0;
  min-width: 0;
  height: 40px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: 6px;
  font-family: var(--mantine-font-family-monospace);
  font-size: 14px;
  font-weight: 500;
  color: var(--mantine-color-gray-9);
  white-space: nowrap;
  touch-action: manipulation;
  transition:
    background 100ms ease,
    border-color 120ms ease;

  &:active:not(:disabled) {
    background: #f6f7f8;
  }

  &[data-active] {
    background: var(--mantine-primary-color-light);
    border-color: var(--mantine-primary-color-filled);
    color: var(--mantine-primary-color-filled);
    font-weight: 600;
  }

  &:disabled {
    color: var(--mantine-color-gray-5);
    cursor: default;
  }
}
